import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { fetchWithCSRF } from '../utils/csrfUtils';


export const useAddMealToMealPlanByDate = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const { sessionToken } = useAuth();



  const addMealToMealPlanByDate = async (mealData) => {
    setIsLoading(true);
    setError(null);

    console.log('Meal data received in hook(with CSRF):', JSON.stringify(mealData));
    
    try {

      if (!sessionToken) {
        throw new Error('No valid session found');
      }

      const response = await fetchWithCSRF('/api/v1/meal/meal_plan_by_date_and_refresh', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${sessionToken}`
        },
        body: JSON.stringify(mealData)
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to add meal to plan');
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      setError(error);
      console.error('Error:', error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  return { addMealToMealPlanByDate, isLoading, error };
};